export const FUND_STATUS_INTERACTIONS_STORE = 'fundStatusInteractions';
